import { DateTime } from 'luxon';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { E_IDENTITY_STATUS } from 'src/ui/views/dynamics/CaseGlobalViewPage/sections/CaseInformation/types';
export var parseLastIdentityStatusUpdate = function (ISODate, timeForSLA) {
    var ISOToMilli = DateTime.fromISO(ISODate).toMillis();
    var now = DateTime.now();
    var diffFromNow = Math.floor((now - ISOToMilli) / 1000);
    var minutes = Math.floor(diffFromNow / 60);
    var seconds = Math.floor(diffFromNow % 60);
    var timezoneSLA = timeForSLA || 5;
    if (minutes < 1) {
        return {
            label: "".concat(seconds, "s"),
            color: null,
        };
    }
    else if (minutes < timezoneSLA) {
        return {
            label: "".concat(minutes, "min ").concat(seconds, "s"),
            color: null,
        };
    }
    else if (minutes < 60) {
        return {
            label: "".concat(minutes, "min"),
            color: null,
        };
    }
    else if (minutes >= 60) {
        var sinceHour = Math.floor(minutes / 60);
        if (sinceHour < 24) {
            return {
                label: "".concat(sinceHour, "h"),
                color: null,
            };
        }
        else {
            var diffDay = Math.floor(sinceHour / 24);
            var restOfHour = sinceHour % 24;
            return {
                label: "".concat(diffDay, "d ").concat(restOfHour, "h"),
                color: null,
            };
        }
    }
    return {
        label: ISODate || '',
        color: null,
    };
};
export var getIdentityIcon = function (currentIdentityStatus) {
    switch (currentIdentityStatus) {
        case E_IDENTITY_STATUS.NEVER_COMPLETED:
            return E_ICONS.IDENTITY_NEVER_COMPLETED;
        case E_IDENTITY_STATUS.INCOMPLETE:
            return E_ICONS.IDENTITY_INCOMPLETED;
        case E_IDENTITY_STATUS.VALID:
            return E_ICONS.IDENTITY_VALID;
        case E_IDENTITY_STATUS.TO_STUDY:
            return E_ICONS.IDENTITY_TO_STUDY;
        case E_IDENTITY_STATUS.FRAUD:
            return E_ICONS.IDENTITY_FRAUD;
        case E_IDENTITY_STATUS.FEB_EXCEPTION:
            return E_ICONS.USER;
        default: {
            return null;
        }
    }
};
